import NoteTypeService from "../NoteType/NoteType.service";
export default class NoteService {
    static fromJSON(json) {
        // @ts-expect-error - TS2740 - Type '{ id: number; createdDate: Date; modifiedDate: Date; noteTypes: any; editableUntil: Date | null; }' is missing the following properties from type 'Note': author, person, text, editable, and 4 more.
        return Object.assign(Object.assign({}, json), { id: parseInt(json.id, 0), createdDate: new Date(json.createdDate), modifiedDate: new Date(json.modifiedDate), noteTypes: (json.noteTypes && json.noteTypes.map(NoteTypeService.fromJSON)) || [], editableUntil: json.editableTimeRemaining && json.editableTimeRemaining >= 0
                ? new Date(json.editableTimeRemaining + new Date().getTime())
                : null });
    }
}
